import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';

import { Button, Paper, MenuItem, Radio, Typography, Divider } from 'material-ui';
import Select from 'react-select';
import 'react-select/dist/react-select.css'
import TextField from 'material-ui/TextField';
import $ from "jquery";
import Formsy from 'formsy-react';
import Loader from "other-components/loader/loader";
import Checkbox from 'material-ui/Checkbox';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';

import axios from 'axios';
import Tooltip from 'material-ui/Tooltip';
import Card, { CardActions, CardContent } from 'material-ui/Card';

import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle,
} from 'material-ui/Dialog';
import ReactTable from "react-table";
import DayPickerInput from 'react-day-picker/DayPickerInput';

import { withAlert } from 'react-alert';
import { Route, Redirect } from 'react-router'

const styles = theme => ({
    layoutRoot: {},

});

const tdStyle = { 'width': '14.285714%' };

var viewLedgerAccount = null;
var viewDescription = null;
var viewAmount = null;

var paymentModeIdAr = [];
var ledgerDetailIdAr = [];

var initialState = {
    currentDate: null,
    transactionDate: '',
    referenceNumber: '',
    payee: '',
    amount: 0,

    //loadBanks: [],
    selectedBank: '',
    //bankAccountNumbers: [],
    //loadLedgerAccounts: [],
    selectedLedgerAccount: "",
    selectedLedgerAccountName: '',
    transactionDate: null,

    ledgerAccountDetailObjById: "",
    ledgerAccountDetailObjAr: [],
    ledgerAccountDetailObjArSave: [],
    ledgerAccountDetailObjArRowId: 0,
    totalAmount: 0,
    totalAmountSave: 0,

    selectedPaymentType: 0,
    // loadPayTypes: [{ value: "cash", label: "Cash" },
    // { value: "card", label: "Card" },
    // { value: "cheque", label: "Cheque" },
    // { value: "bank", label: "Bank Deposit" }],
    // loadPayTypes: [],

    // payment method cards hidden
    cashCardHidden: true,
    cardCardHidden: true,
    cardChequeHidden: true,
    cardBankDepositHidden: true,

    paymentModeAr: [],
    paymentModeArRowId: 0,
    totalOfPayedPaymentMode: 0,

    rediret: false,
    imageURL: 'assets/images/theme-options/content-only.jpg',

    draftId: '',
    draftData: null,
    draftDetailsTableAr: [],
};

class NormalPayment extends Component {

    state = {
        value: 0
    };



    constructor(props) {
        super(props);

        this.state = {
            currentDate: null,
            transactionDate: '',
            referenceNumber: '',
            payee: '',
            amount: 0,

            loadBanks: [],
            selectedBank: '',
            bankAccountNumbers: [],
            loadLedgerAccounts: [],
            selectedLedgerAccount: "",
            selectedLedgerAccountName: '',
            transactionDate: null,

            ledgerAccountDetailObjById: "",
            ledgerAccountDetailObjAr: [],
            ledgerAccountDetailObjArSave: [],
            ledgerAccountDetailObjArRowId: 0,
            totalAmount: 0,

            selectedPaymentType: 0,
            // loadPayTypes: [{ value: "cash", label: "Cash" },
            // { value: "card", label: "Card" },
            // { value: "cheque", label: "Cheque" },
            // { value: "bank", label: "Bank Deposit" }],
            loadPayTypes: [],

            // payment method cards hidden
            cashCardHidden: true,
            cardCardHidden: true,
            cardChequeHidden: true,
            cardBankDepositHidden: true,

            paymentModeAr: [],
            paymentModeArRowId: 0,
            totalOfPayedPaymentMode: 0,

            rediret: false,
            imageURL: 'assets/images/theme-options/content-only.jpg',

            draftId: '',
            draftData: null,
            draftDetailsTableAr: [],
        };

        this.loadCurrentDate();
        this.loadBanks();
        this.loadLedgerAccounts();
        this.loadPaymentTypesDB();
        this.loadAllDraftDetails();

        this.handleTransactionDateChange = this.handleTransactionDateChange.bind(this);
        this.getLedgerAccDetails = this.getLedgerAccDetails.bind(this);
        this.loadPaymentTypes = this.loadPaymentTypes.bind(this);
        this.handleUploadImage = this.handleUploadImage.bind(this);
        this.removeAttachment = this.removeAttachment.bind(this);
        this.clearFields = this.clearFields.bind(this);
    }

    handleCloseView = () => {
        this.setState({ viewPayment: false });
    };

    onView = (model) => {
    };

    removeAttachment() {
        this.setState({ imageURL: 'assets/images/theme-options/content-only.jpg' })
    }

    // get current date
    loadCurrentDate() {
        var date = new Date();
        var formatedDate = ((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()).toString();
        this.setState({ currentDate: formatedDate });
    }

    // set transaction date
    handleTransactionDateChange(date) {
        console.log('changeDate', date);
        this.setState({
            transactionDate: date
        });
    }

    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    // load payment types 
    loadPaymentTypesDB() {
        var paymentTypes = [];

        // axios.get(window.systemServer + '/system/loadBanks')
        axios.get(window.accountServer + '/normalPayment/getPaymentTypes')
            .then(response => {

                if (response.data.success) {
                    for (let i = 0; i < response.data.paymentTypes.length; i++) {

                        paymentTypes.push({
                            value: response.data.paymentTypes[i].ID_PAYMENT_TYPE,
                            label: response.data.paymentTypes[i].NAME
                        });
                    }
                    this.setState({ loadPayTypes: paymentTypes });
                } else {
                    console.log('payment type loding faild');
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error loding payment types");
                // alert("No internet connection or Internal error");
            });
    }

    // load banks
    loadBanks() {
        var loadBanks = [];

        axios.get(window.systemServer + '/system/loadBanks')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadBanks.push({
                            value: response.data.result[i].bank_name,
                            label: response.data.result[i].bank_name
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {

                        loadBanks.push({
                            label: response.data[i].bank_name,
                            value: response.data[i].bank_name
                        });
                    }
                this.setState({ loadBanks: loadBanks });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
            });
    }

    // load bank account numbers where bank
    loadBannkAccountNumers = (selectedOption) => {

        if (null == selectedOption) {
            this.setState({ selectedBank: '' });
        } else {
            this.setState({ selectedBank: selectedOption.value });

            var bankAccountNumbers = [];

            var bankName = {
                bankName: selectedOption.value
            }

            axios.post(window.accountServer + '/bank/loadBankAccountNumbers', bankName)
                .then(response => {

                    for (let i = 0; i < response.data.accountNumbers.length; i++) {

                        bankAccountNumbers.push({
                            label: response.data.accountNumbers[i].ACCOUNT_NO,
                            value: response.data.accountNumbers[i].ID_LEDGER_ACCOUNT
                        });
                    }
                    this.setState({ bankAccountNumbers: bankAccountNumbers });

                }).catch(function (error) {
                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }

    }

    // load ledger accounts 
    loadLedgerAccounts() {
        this.setState({ loading: true });

        var loadLedgerAccounts = [];

        axios.get(window.accountServer + '/ledgerAccount/getLedgerAccountDetails')
            .then(response => {

                if (response.data.success) {
                    var ledgerAccObj = response.data.ledgerAccountDetails;

                    console.log("ledgerAccountDetails ", ledgerAccObj);

                    for (var i = 0; i < ledgerAccObj.length; i++) {

                        loadLedgerAccounts.push({
                            value: ledgerAccObj[i].ID_LEDGER_ACCOUNT,
                            label: ledgerAccObj[i].NAME
                        });
                    }
                } else {
                    console.log("No results found ledger account details");
                }

                this.setState({ loadLedgerAccounts: loadLedgerAccounts });
                this.setState({ loading: false });

            }).catch(function (error) {
                // alert(error);
                console.log("ledger detail err " + error);
                console.log("No internet connection or Internal error");
                this.setState({ loading: false });
                // alert("No internet connection or Internal error");
            });
    }

    // set selected ledger acount into field
    // load data relevant ledger account 
    getLedgerAccDetails = (selectedOption) => {

        if (selectedOption == null) {

            this.state.ledgerAccountDetailObjById.DESCRIPTION = '';
            this.setState({ amount: 0 });
            this.setState({ imageURL: 'assets/images/theme-options/content-only.jpg' });
            this.setState({ selectedLedgerAccount: '' });
            this.setState({ selectedLedgerAccountName: '' });

        } else {
            this.setState({ selectedLedgerAccount: selectedOption.value });
            this.setState({ selectedLedgerAccountName: selectedOption.label });
            // alert(selectedOption.value);
            this.setState({ loading: true });

            axios.post(window.accountServer + '/ledgerAccount/getLedgerAccountDetailsById', { accId: selectedOption.value })
                // axios.post(window.accountServer+'/ledgerAccount/getLedgerAccountDetailsById', { accId: selectedOption.value })

                .then(response => {
                    if (null == response.data.ledgerDetails || undefined == response.data.ledgerDetails || 0 == response.data.ledgerDetails.length) {

                        this.props.alert.error("No details to view");
                        this.setState({ loading: false });

                    } else {
                        var ledgerAccDetails = response.data.ledgerDetails;
                        console.log("ledgerAccountDetails : ", ledgerAccDetails);

                        this.setState({ ledgerAccountDetailObjById: ledgerAccDetails[0] });

                        this.setState({ loading: false });
                    }

                }).catch(function (error) {
                    // alert(error);
                    console.log("cust detail err " + error);
                    console.log("No internet connection or Internal error");
                    this.setState({ loading: false });
                    // alert("No internet connection or Internal error");
                });
        }
    }

    //// add ledger account details and paid amount into table
    addLedgerDetailsIntoTable(e) {

        var amount1 = this.state.amount;
        if (amount1 <= 0 || amount1 == undefined || '' == amount1 || null == amount1) {
            this.props.alert.info("Invalid Amount !");
        } else {
            this.state.ledgerAccountDetailObjArRowId = this.state.ledgerAccountDetailObjArRowId + 1;

            // for adding to table
            var ledgerAccountDetailObj = {
                rowIdad: this.state.ledgerAccountDetailObjArRowId,
                ledgerAccountId: this.state.selectedLedgerAccount,
                ledgerAccountName: this.state.selectedLedgerAccountName,
                description: this.state.ledgerAccountDetailObjById.DESCRIPTION,
                amount: this.state.amount
            };

            // for saving
            var ledgerAccountDetailObjSave = {
                ID_LEDGER_ACCOUNT: this.state.selectedLedgerAccount,
                LEDGER_NAME: this.state.selectedLedgerAccountName,
                DESCRIPTION: this.state.ledgerAccountDetailObjById.DESCRIPTION,
                CR: 0,
                DR: this.state.amount
            };

            // for adding to table
            this.setState(prevState => ({
                ledgerAccountDetailObjAr: [...prevState.ledgerAccountDetailObjAr, ledgerAccountDetailObj]
            }));

            // for saving 
            this.setState(prevState => ({
                ledgerAccountDetailObjArSave: [...prevState.ledgerAccountDetailObjArSave, ledgerAccountDetailObjSave]
            }));

            // set total
            var totalAmount = parseFloat(this.state.totalAmount) + parseFloat(this.state.amount);
            var totalAmountSave = parseFloat(this.state.totalAmount) + parseFloat(this.state.amount);
            this.setState({
                totalAmount: totalAmount,
                totalAmountSave: totalAmountSave
            });
        }

    }

    // hidden payment methods cards
    loadPaymentTypes = (selectedOption) => {

        if (null == selectedOption) {

            this.setState({ selectedPaymentType: '' });

            this.setState({ cashCardHidden: true });
            this.setState({ cardCardHidden: true });
            this.setState({ cardChequeHidden: true });
            this.setState({ cardBankDepositHidden: true });

        } else {
            var selectPaymentType = selectedOption.value;

            this.setState({ selectedPaymentType: selectPaymentType });

            if (1 == selectPaymentType) {
                this.setState({ cashCardHidden: false });

                this.setState({ cardCardHidden: true });
                this.setState({ cardChequeHidden: true });
                this.setState({ cardBankDepositHidden: true });
            }

            if (3 == selectPaymentType) {
                this.setState({ cardCardHidden: false });

                this.setState({ cashCardHidden: true });
                this.setState({ cardChequeHidden: true });
                this.setState({ cardBankDepositHidden: true });
            }

            if (2 == selectPaymentType) {
                this.setState({ cardChequeHidden: false });

                this.setState({ cashCardHidden: true });
                this.setState({ cardCardHidden: true });
                this.setState({ cardBankDepositHidden: true });
            }

            if (4 == selectPaymentType) {
                this.setState({ cardBankDepositHidden: false });

                this.setState({ cashCardHidden: true });
                this.setState({ cardCardHidden: true });
                this.setState({ cardChequeHidden: true });
            }
        }

    }

    // add cash details to table
    addCashAmountT = (model) => {

        var cashAmount = model.cashAmount;
        if (cashAmount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {

            this.state.paymentModeArRowId = this.state.paymentModeArRowId + 1;
            var paymentMode = {}

            paymentMode.rowIdpm = this.state.paymentModeArRowId;
            paymentMode.paymentTypeName = 'Cash';
            paymentMode.paymentType = 1;
            paymentMode.cardType = "";
            paymentMode.bank = "";
            paymentMode.branch = "";
            paymentMode.accountNo = "";
            paymentMode.cardNo = "";
            paymentMode.chequeNo = "";
            paymentMode.cardExpireDate = "";
            paymentMode.depositDate = "";
            paymentMode.slipNo = "";
            paymentMode.number = "";
            paymentMode.date = "";
            paymentMode.paymentAmount = cashAmount;

            var reduiceTotal = parseFloat(this.state.totalAmount) - parseFloat(cashAmount);
            if (0 <= reduiceTotal) {

                this.setState({ totalAmount: reduiceTotal.toFixed(2) });
                this.setState(prevState => ({
                    paymentModeAr: [...prevState.paymentModeAr, paymentMode]
                }));

                this.setState({ cashCardHidden: true });
            } else {
                this.props.alert.info("Big value");
            }
        }

    };

    // add card details to table
    addCardAmountT = (model) => {

        var cardType = model.cardType;
        var bankName = model.bankName;
        var cardNo = model.cardNo;
        var amount = model.amount;

        if (amount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {

            this.state.paymentModeArRowId = this.state.paymentModeArRowId + 1;
            var paymentMode = {}

            paymentMode.rowIdpm = this.state.paymentModeArRowId;
            paymentMode.paymentTypeName = 'Card';
            paymentMode.paymentType = 3;
            paymentMode.cardType = model.cardType;
            paymentMode.bank = bankName;
            paymentMode.branch = "";
            paymentMode.accountNo = "";
            paymentMode.cardNo = cardNo;
            paymentMode.number = cardNo;
            paymentMode.chequeNo = "";
            paymentMode.cardExpireDate = model.expiredDate;
            paymentMode.depositDate = "";
            paymentMode.slipNo = "";
            paymentMode.date = model.expiredDate;
            paymentMode.paymentAmount = amount;

            var reduiceTotal = parseFloat(this.state.totalAmount) - parseFloat(amount);
            if (0 <= reduiceTotal) {

                this.setState({ totalAmount: reduiceTotal.toFixed(2) });
                this.setState(prevState => ({
                    paymentModeAr: [...prevState.paymentModeAr, paymentMode]
                }))

                this.setState({ cardCardHidden: true })
            } else {
                this.props.alert.info("Big value");
            }
        }
    };

    // add cheque Details to table
    addChequeAmountT = (model) => {

        // var bankName = model.bankName;
        var bankName = this.state.selectedBank;
        var accountNo = model.accountNo;
        var chequeNo = model.chequeNo;
        var chequeDate = model.chequeDate;
        var amount = model.amount;

        if (amount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {
            this.state.paymentModeArRowId = this.state.paymentModeArRowId + 1;
            var paymentMode = {}

            paymentMode.rowIdpm = this.state.paymentModeArRowId;
            paymentMode.paymentTypeName = 'Cheque';
            paymentMode.paymentType = 2;
            paymentMode.cardType = "";
            paymentMode.bank = bankName;
            paymentMode.branch = "";
            paymentMode.accountNo = accountNo;
            paymentMode.cardNo = "";
            paymentMode.number = chequeNo;
            paymentMode.chequeNo = chequeNo;
            paymentMode.cardExpireDate = "";
            paymentMode.depositDate = "";
            paymentMode.slipNo = "";
            paymentMode.date = chequeDate;
            paymentMode.paymentAmount = amount;

            var reduiceTotal = parseFloat(this.state.totalAmount) - parseFloat(amount);
            if (0 <= reduiceTotal) {

                this.setState({ totalAmount: reduiceTotal.toFixed(2) });
                this.setState(prevState => ({
                    paymentModeAr: [...prevState.paymentModeAr, paymentMode]
                }));

                this.setState({ cardChequeHidden: true });
            } else {
                this.props.alert.info("Big value");
            }
        }
    }

    // add bank Details to table
    addBankDepositAmountT = (model) => {

        var bankName = model.bankName;
        var branch = model.branch;
        var receiptNo = model.receiptNo;
        var depositDate = model.depositDate;
        var amount = model.amount;

        if (amount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {

            this.state.paymentModeArRowId = this.state.paymentModeArRowId + 1;
            var paymentMode = {}

            paymentMode.rowIdpm = this.state.paymentModeArRowId;
            paymentMode.paymentTypeName = 'Bank Deposit';
            paymentMode.paymentType = 4;
            paymentMode.cardType = "";
            paymentMode.bank = bankName;
            paymentMode.branch = model.branch;
            paymentMode.accountNo = "";
            paymentMode.cardNo = "";
            paymentMode.number = receiptNo;
            paymentMode.chequeNo = "";
            paymentMode.cardExpireDate = "";
            paymentMode.depositDate = depositDate;
            paymentMode.slipNo = receiptNo;
            paymentMode.date = depositDate;
            paymentMode.paymentAmount = amount;

            var reduiceTotal = parseFloat(this.state.totalAmount) - parseFloat(amount);
            if (0 <= reduiceTotal) {

                this.setState({ totalAmount: reduiceTotal.toFixed(2) });
                this.setState(prevState => ({
                    paymentModeAr: [...prevState.paymentModeAr, paymentMode]
                }));

                this.setState({ cardBankDepositHidden: true });
            } else {
                this.props.alert.info("Big value");
            }
        }
    }

    // romove payment mode
    removePaymentMode(rowId, paymentAmount) {

        var paidPaymentModeAr = this.state.paymentModeAr;
        var index = paidPaymentModeAr.findIndex(x => x.rowIdpm == rowId);
        var removedVal = parseFloat(paymentAmount);

        paidPaymentModeAr.splice(index, 1);
        this.setState({ paymentModeAr: paidPaymentModeAr });

        var oldTotal = this.state.totalOfPayedPaymentMode;
        var newTotal = (oldTotal - removedVal);
        this.setState({ totalOfPayedPaymentMode: newTotal });

        var newPaymentTot = parseFloat(this.state.totalAmount) + removedVal;

        this.setState({ totalAmount: newPaymentTot.toFixed(2) });

        paymentModeIdAr.splice(rowId, 1);
    }

    // romove ledger account
    removeLedgerAccDetail(rowId, amount) {

        var accountDetailAr = this.state.ledgerAccountDetailObjAr;
        var index = accountDetailAr.findIndex(x => x.rowIdad == rowId);
        var removedVal = parseFloat(amount);

        accountDetailAr.splice(index, 1);
        this.setState({ ledgerAccountDetailObjAr: accountDetailAr });
        this.setState({ ledgerAccountDetailObjArSave: accountDetailAr });

        var oldTotal = this.state.totalAmount;
        var newTotal = (oldTotal - removedVal);
        this.setState({ totalAmount: newTotal });

        ledgerDetailIdAr.splice(rowId, 1);
    }

    // redirect add new ledger account page

    addNew() {
        this.setState({ redirect: true })
    }

    redirectToDN() {
        if (this.state.redirect) {
            return (
                <Redirect
                    to={{
                        // pathname: "/sales/deliveryNote",
                        pathname: "/account/ledger"
                        // state: { refNo: this.state.refParser}
                    }}
                />
            )
        }
    }



    // save normal payment
    saveNormalPayment() {

        this.setState({ loading: true });

        var ledgerAccountHeader = {
            TANSACTION_TYPE: 'NORMAL',
            DOCUMENT_NO: null,
            DATE: this.state.transactionDate,
            REFERENCE_ID: this.state.referenceNumber,
            PAYEE: this.state.payee,
            TOTAL_AMOUNT: this.state.totalAmountSave,
            ATTACHMENT_PATH: this.state.imageURL,
            STATUS: null,
            DRAFT_ID: this.state.draftId,
        };

        var ledgerAccountDetailAr = this.state.ledgerAccountDetailObjArSave;
        var paymentModeAr = this.state.paymentModeAr;

        console.log('ledgerAccountDetailAr', ledgerAccountDetailAr);

        // set ids into state
        ledgerDetailIdAr = [];
        for (var a = 0; a < ledgerAccountDetailAr.length; a++) {
            // console.log("AR ", ledgerAccountDetailAr[a].ID_LEDGER_ACCOUNT);
            ledgerDetailIdAr.push(ledgerAccountDetailAr[a].ID_LEDGER_ACCOUNT);
        }
        // console.log("Sheyan ", ledgerDetailIdAr);
        // this.setState({ ledgerDetailIdAr: ledgerDetailIdAr });
        // console.log("snada ", this.state.ledgerDetailIdAr);


        paymentModeIdAr = [];
        for (var b = 0; b < paymentModeAr.length; b++) {
            paymentModeIdAr.push(paymentModeAr[b].paymentType);
        }
        // this.setState({ paymentModeIdAr: paymentModeIdAr });
        //////////////////////////////////////////////////////

        if (null == this.state.transactionDate || undefined == this.state.transactionDate || "" == this.state.transactionDate) {

            this.props.alert.info("Input transaction date first !");
            this.setState({ loading: false });
        } else {

            if (0 == ledgerAccountDetailAr.length || null == ledgerAccountDetailAr || undefined == ledgerAccountDetailAr) {

                this.props.alert.info("No any payment to save !");
                this.setState({ loading: false });
            } else {

                if (0 == paymentModeAr.length || null == paymentModeAr || undefined == paymentModeAr) {

                    this.props.alert.info("No any payment method to save !");
                    this.setState({ loading: false });
                } else {

                    /////////////
                    var allLedgerDetailsSame = ledgerDetailIdAr.allValuesSame();
                    console.log("vvvv ", ledgerDetailIdAr);
                    // alert("allLedgerDetailsSame " + allLedgerDetailsSame);

                    if (allLedgerDetailsSame) {
                        console.log("allLedgerDetailsSame");
                        this.saveMethod(paymentModeAr, ledgerAccountHeader, ledgerAccountDetailAr);
                    } else {
                        console.log("NOT allLedgerDetailsSame");
                        var allPaymodesSame = paymentModeIdAr.allValuesSame();
                        // alert("allPaymodesSame " + allPaymodesSame);

                        if (allPaymodesSame) {
                            console.log("allPaymodesSame");
                            this.saveMethod(paymentModeAr, ledgerAccountHeader, ledgerAccountDetailAr);
                        } else {
                            console.log("NOT allPaymodesSame");
                            this.props.alert.info("Connot save diffrent paymode and ledger account");
                            this.setState({ loading: false });
                        }
                    }

                }
            }
        }
    }

    // calling common save method
    saveMethod(paymentModeAr, ledgerAccountHeader, ledgerAccountDetailAr) {
        var totalOfPayedPaymentMode = 0;
        for (var j = 0; j < paymentModeAr.length; j++) {
            totalOfPayedPaymentMode = totalOfPayedPaymentMode + parseFloat(paymentModeAr[j].paymentAmount);
        }

        this.setState({ totalOfPayedPaymentMode: totalOfPayedPaymentMode });

        if (this.state.totalAmount != 0.00) {

            console.log('this.state.totalAmount', this.state.totalAmount);
            this.props.alert.info("Not Enough Amount");
            this.setState({ loading: false });
            // } else if (this.state.totalAmount < totalOfPayedPaymentMode) {

            //     this.props.alert.info("Big Amount");
            //     this.setState({ loading: false });
        } else {

            var normalPaymentObj = {
                transactionLedgerHeader: ledgerAccountHeader,
                transactionLedgerDetails: ledgerAccountDetailAr,
                paymentModeAr: paymentModeAr
            };

            axios.post(window.accountServer + '/normalPayment/savePaymodeLedgerBulkPayment', normalPaymentObj)
                // axios.post('http://localhost:5009/normalPayment/savePaymodeLedgerBulkPayment', normalPaymentObj)

                .then(response => {
                    if (response.data.success) {

                        this.setState({ ledgerAccountDetailObjAr: [] });
                        this.setState({ ledgerAccountDetailObjArSave: [] });
                        this.setState({ draftDetailsTableAr: [] });
                        this.setState({ paymentModeAr: [] });
                        paymentModeIdAr = [];
                        ledgerDetailIdAr = [];

                        this.loadAllDraftDetails();
                        this.resetAll();
                        this.props.alert.success("Payment Saved Successfully");
                        this.setState({ loading: false });

                        var Paymentid = response.data.normalPaymetDetailObj.DETAIL[0].ID_TRANSACTION_LEDGER_HEADER;
                        //alert(Paymentid)

                        var path = null;
                        axios.get(window.reportServer + '/pettyCashReport/get/payment', {
                            // axios.get('http://localhost:5008/pettyCashReport/get/payment', {
                            params: {
                                id: Paymentid
                            }
                        })
                            .then(response => {
                                console.log('get normal payment cash path', response);

                                path = response.data.path;
                                path = window.reportServer + "/" + path;
                                const url = path;
                                console.log(path)
                                window.open(url, '_blank');
                                // if (cb) {
                                //     cb();
                                // }
                            }
                            )
                            .catch((error) => {
                                if (error) {
                                    console.log('get Nomal Payment Report error', error);
                                } else {
                                    console.log('get Nomal Payment Report error');
                                }
                            });

                    } else {

                        this.props.alert.error("Canot Save Pyamnet !");
                        this.setState({ loading: false });
                    }

                }).catch(function (error) {
                    // alert(error);
                    console.log("server er : ", error);
                    console.log("No internet connection or Internal error");
                    this.setState({ loading: false });
                });
        }
    }

    // draft normal Payment
    draftNormalPayment() {
        this.setState({ loading: true });

        var ledgerAccountHeader = {
            TANSACTION_TYPE: 'NORMAL',
            DOCUMENT_NO: null,
            DATE: this.state.transactionDate,
            REFERENCE_ID: this.state.referenceNumber,
            PAYEE: this.state.payee,
            TOTAL_AMOUNT: this.state.totalAmountSave,
            ATTACHMENT_PATH: this.state.imageURL,
            STATUS: null
        };


        var ledgerAccountDetailAr = this.state.ledgerAccountDetailObjArSave;
        var paymentModeAr = this.state.paymentModeAr;

        ledgerDetailIdAr = [];
        for (var a = 0; a < ledgerAccountDetailAr.length; a++) {
            // console.log("AR ", ledgerAccountDetailAr[a].ID_LEDGER_ACCOUNT);
            ledgerDetailIdAr.push(ledgerAccountDetailAr[a].ID_LEDGER_ACCOUNT);
        }

        paymentModeIdAr = [];
        for (var b = 0; b < paymentModeAr.length; b++) {
            paymentModeIdAr.push(paymentModeAr[b].paymentType);
        }

        if (null == this.state.transactionDate || undefined == this.state.transactionDate || "" == this.state.transactionDate) {

            this.props.alert.info("Input transaction date first !");
            this.setState({ loading: false });
        } else {

            if (0 == ledgerAccountDetailAr.length || null == ledgerAccountDetailAr || undefined == ledgerAccountDetailAr) {

                this.props.alert.info("No any payment to save !");
                this.setState({ loading: false });
            } else {

                /////////////
                var allLedgerDetailsSame = ledgerDetailIdAr.allValuesSame();

                if (allLedgerDetailsSame) {
                    console.log("allLedgerDetailsSame");
                    this.saveDraftMethod(paymentModeAr, ledgerAccountHeader, ledgerAccountDetailAr);
                } else {
                    console.log("NOT allLedgerDetailsSame");
                    var allPaymodesSame = paymentModeIdAr.allValuesSame();
                    // alert("allPaymodesSame " + allPaymodesSame);

                    if (allPaymodesSame) {
                        console.log("allPaymodesSame");
                        this.saveDraftMethod(paymentModeAr, ledgerAccountHeader, ledgerAccountDetailAr);
                    } else {
                        console.log("NOT allPaymodesSame");
                        this.props.alert.info("Connot save diffrent paymode and ledger account");
                        this.setState({ loading: false });
                    }
                }
            }
        }
    }

    // save draft common method
    saveDraftMethod(paymentModeAr, ledgerAccountHeader, ledgerAccountDetailAr) {
        var totalOfPayedPaymentMode = 0;
        for (var j = 0; j < paymentModeAr.length; j++) {
            totalOfPayedPaymentMode = totalOfPayedPaymentMode + parseFloat(paymentModeAr[j].paymentAmount);
        }

        this.setState({ totalOfPayedPaymentMode: totalOfPayedPaymentMode });

        // if (this.state.totalAmount > totalOfPayedPaymentMode) {

        //     this.props.alert.info("Not Enough Amount");
        //     this.setState({ loading: false });
        // } else if (this.state.totalAmount < totalOfPayedPaymentMode) {

        //     this.props.alert.info("Big Amount");
        //     this.setState({ loading: false });
        // } else {

        var normalPaymentObj = {
            transactionLedgerHeader: ledgerAccountHeader,
            transactionLedgerDetails: ledgerAccountDetailAr,
            paymentModeAr: paymentModeAr
        };

        axios.post(window.accountServer + '/normalPayment/draftPaymodeLedgerBulkPayment', normalPaymentObj)
            // axios.post('http://localhost:5009/normalPayment/draftPaymodeLedgerBulkPayment', normalPaymentObj)

            .then(response => {
                if (response.data.success) {

                    this.state.ledgerAccountDetailObjAr = [];
                    this.setState({ paymentModeAr: [] });
                    this.setState({ ledgerAccountDetailObjArSave: [] });
                    paymentModeIdAr = [];
                    ledgerDetailIdAr = [];
                    this.resetAll();
                    this.loadAllDraftDetails();
                    this.props.alert.success("Payment Saved as a Draft Successfully");
                    this.setState({ loading: false });

                } else {

                    this.props.alert.error("Canot Saved Pyamnet as a draft!");
                    this.setState({ loading: false });
                }

            }).catch(function (error) {
                // alert(error);
                console.log("server er : ", error);
                console.log("No internet connection or Internal error");
                this.setState({ loading: false });
            });
        // }
    }

    // image upload function
    handleUploadImage() {

        const data = new FormData();
        data.append('file', this.uploadInput.files[0]);
        data.append('filename', this.fileName.value);

        fetch(window.imageUploadServer + '/upload', {
            method: 'POST',
            body: data,
        }).then((response) => {

            response.json().then((body) => {
                this.setState({ imageURL: window.imageUploadServer + `/${body.file}` });
            });
        });
    }

    clearFields() {
        this.setState({
            ...initialState,
            transactionDate: ''
        });
    }

    // reset fields
    resetAll() {

        this.setState({
            currentDate: null,
            transactionDate: '',
            referenceNumber: '',
            payee: '',
            amount: 0,

            selectedLedgerAccount: "",
            selectedLedgerAccountName: '',
            transactionDate: null,

            ledgerAccountDetailObjById: "",

            ledgerAccountDetailObjArRowId: 0,
            totalAmount: 0,

            selectedPaymentType: 0,

            // payment method cards hidden
            cashCardHidden: true,
            cardCardHidden: true,
            cardChequeHidden: true,
            cardBankDepositHidden: true,

            paymentModeArRowId: 0,
            totalOfPayedPaymentMode: 0,

            rediret: false,
            imageURL: 'assets/images/theme-options/content-only.jpg'
        });
    }

    // get draft details
    loadAllDraftDetails() {
        this.setState({ loading: true });

        var draftDetailsTableAr = [];

        axios.get(window.accountServer + '/normalPayment/getAllDraftDetails')
            // axios.get('http://localhost:5009/normalPayment/getAllDraftDetails')
            .then(response => {

                if (response.data.success) {

                    for (let i = 0; i < response.data.draftList.length; i++) {
                        var dd = JSON.parse(response.data.draftList[i].DRAFT_DETAIL);
                        var dds = response.data.draftList;

                        this.setState({ draftData: dds });

                        var transDate = '';
                        if (null == dd.transactionLedgerHeader.DATE || undefined == dd.transactionLedgerHeader.DATE || '' == dd.transactionLedgerHeader.DATE) {
                            transDate = '';
                        } else {
                            transDate = (dd.transactionLedgerHeader.DATE).toString().split("T")[0];
                        }

                        draftDetailsTableAr.push({
                            rowId: i,
                            refId: dd.transactionLedgerHeader.REFERENCE_ID,
                            transType: dd.transactionLedgerHeader.TANSACTION_TYPE,
                            totalAmount: dd.transactionLedgerHeader.TOTAL_AMOUNT,
                            trasDate: transDate,
                            payee: dd.transactionLedgerHeader.PAYEE,
                            attechmentpath: dd.transactionLedgerHeader.ATTACHMENT_PATH
                        });
                    }
                    this.setState({ draftDetailsTableAr: draftDetailsTableAr });
                    this.setState({ loading: false });

                } else {
                    console.log('payment draft loding faild');
                    this.setState({ loading: false });
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error loding payment types");
                // alert("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    // set all draft details into releted fields
    loadDraftDetailsIntoFields(id) {

        var draftDetailAr = this.state.draftDetailsTableAr;

        console.log("this.state.draftDetailsTableAr ", this.state.draftDetailsTableAr);

        // set ledger account header
        this.setState({ transactionDate: draftDetailAr[id].trasDate });
        this.setState({ referenceNumber: draftDetailAr[id].refId });
        this.setState({ payee: draftDetailAr[id].payee });
        this.setState({ totalAmount: draftDetailAr[id].totalAmount });

        var allDraftDetails = JSON.parse(this.state.draftData[id].DRAFT_DETAIL);
        var did = this.state.draftData[id].ID_DRAFT;
        this.setState({ draftId: did });

        // set ledger account header details
        var draftAccDetailAr = allDraftDetails.ledgerAccountDetailAr;
        var draftAccDetailtableAr = [];
        var draftAccDetailtableArSave = [];

        for (var i = 0; i < draftAccDetailAr.length; i++) {
            draftAccDetailtableAr.push({
                rowIdad: i,
                ledgerAccountId: draftAccDetailAr[i].ID_LEDGER_ACCOUNT,
                ledgerAccountName: draftAccDetailAr[i].LEDGER_NAME,
                description: draftAccDetailAr[i].DESCRIPTION,
                amount: draftAccDetailAr[i].DR
            });

            draftAccDetailtableArSave.push({
                ID_LEDGER_ACCOUNT: draftAccDetailAr[i].ID_LEDGER_ACCOUNT,
                LEDGER_NAME: draftAccDetailAr[i].LEDGER_NAME,
                DESCRIPTION: draftAccDetailAr[i].DESCRIPTION,
                CR: 0,
                DR: draftAccDetailAr[i].DR
            });
        }

        this.setState({ ledgerAccountDetailObjAr: draftAccDetailtableAr });
        this.setState({ ledgerAccountDetailObjArSave: draftAccDetailtableArSave });

        /// set paymode details
        var draftPaymodeAr = allDraftDetails.paymentModeAr;
        var draftPaymodeTableAr = [];
        console.log("all draft details ", draftPaymodeAr);

        for (var j = 0; j < draftPaymodeAr.length; j++) {

            // var paymentType = '';
            // if(1 == draftPaymodeAr[j].paymentType){
            //     paymentType = 'Cash';
            // }
            // if(2 == draftPaymodeAr[j].paymentType){
            //     paymentType = 'Cheque';
            // }
            // if(3 == draftPaymodeAr[j].paymentType){
            //     paymentType = 'Card';
            // }
            // if(4 == draftPaymodeAr[j].paymentType){
            //     paymentType = 'Bank Deposit';
            // }

            draftPaymodeTableAr.push({
                rowIdpm: j,
                paymentType: draftPaymodeAr[j].paymentType,
                paymentTypeName: draftPaymodeAr[j].paymentTypeName,
                cardType: draftPaymodeAr[j].cardType,
                bank: draftPaymodeAr[j].bank,
                branch: draftPaymodeAr[j].branch,
                accountNo: draftPaymodeAr[j].accountNo,
                cardNo: draftPaymodeAr[j].cardNo,
                chequeNo: draftPaymodeAr[j].chequeNo,
                cardExpireDate: draftPaymodeAr[j].cardExpireDate,
                depositDate: draftPaymodeAr[j].depositDate,
                slipNo: draftPaymodeAr[j].slipNo,
                number: draftPaymodeAr[j].number,
                date: draftPaymodeAr[j].date,
                paymentAmount: draftPaymodeAr[j].paymentAmount,
            });
        }

        this.setState({ paymentModeAr: draftPaymodeTableAr });

    }

    render() {
        // check array values a same
        Array.prototype.allValuesSame = function () {

            for (var i = 1; i < this.length; i++) {
                if (this[i] !== this[0])
                    return false;
            }

            return true;
        };


        const { classes } = this.props;
        const { value } = this.state;
        if (this.state.loading) {
            return (<Loader />);
        }
        else {
            return (
                <FusePageSimple
                    classes={{
                        root: classes.layoutRoot
                    }}

                    contentToolbar={
                        <div className="px-24"><h2 className="subtitle-color">Normal Payment</h2></div>
                    }
                    content={
                        <div className="p-24 {classes.root}">
                            <div className="p-24 {classes.root} ">

                                <div className="block">

                                    <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">
                                        <p>Transaction Date</p>
                                        <DayPickerInput
                                            className="bg-orange"
                                            onDayChange={this.handleTransactionDateChange}
                                            selectedDays={this.state.transactionDate}
                                            value={this.state.transactionDate}
                                            onChange={this.handleTextBoxChange('transactionDate')}
                                        />
                                    </div>

                                    <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">
                                        <TextField
                                            className=" "
                                            type="text"
                                            id="refNumber"
                                            name="refNumber"
                                            label="Ref-No"
                                            value={this.state.referenceNumber}
                                            onChange={this.handleTextBoxChange('referenceNumber')}
                                        />
                                    </div>


                                    <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">
                                        <TextField
                                            className=""
                                            type="text"
                                            name="payee"
                                            label="Payee"
                                            value={this.state.payee}
                                            onChange={this.handleTextBoxChange('payee')}
                                        />
                                    </div>

                                    <div class="w-full sm:w-1/2 md:w-2/5 p-8  inline-block">
                                        Draft Table
                                        <ReactTable
                                            getTrProps={(state, rowInfo, column) => {
                                                return {
                                                    className: "cursor-pointer",
                                                    onClick: (e, handleOriginal) => {
                                                        this.loadDraftDetailsIntoFields(rowInfo.original.rowId);
                                                    }
                                                }
                                            }}
                                            data={this.state.draftDetailsTableAr}
                                            columns={[
                                                {
                                                    Header: "rowId",
                                                    accessor: "rowId",
                                                    show: false
                                                },

                                                {
                                                    Header: "Reference No",
                                                    accessor: "refId",
                                                    className: "justify-center"
                                                },
                                                {
                                                    Header: "Date",
                                                    accessor: "trasDate",
                                                    className: "justify-center"
                                                },

                                                {
                                                    Header: "Payee",
                                                    accessor: "payee",
                                                    className: "justify-center"
                                                    // filterable: true
                                                },


                                            ]}
                                            defaultPageSize={2}
                                            className="-striped -highlight"
                                        />
                                    </div>

                                </div>



                                <Divider className="md:mt-16 sm:mt-8" />

                                <                           div className=" block ">
                                    <div className="w-full sm:w-1/2 md:w-2/3 p-8 inline-block ">
                                        <div className="flex flex-wrap mx-3 mb-6">
                                            <div className=" w-full inline-block ">
                                                {/* Note:- Get Old look need to remove upper div */}
                                                <Select
                                                    className="w-full md:w-1/4 mt-24 pr-24"
                                                    name="form-field-name"
                                                    placeholder="Select Ledger Account"
                                                    value={this.state.selectedLedgerAccount}
                                                    onChange={this.getLedgerAccDetails}
                                                    options={this.state.loadLedgerAccounts}
                                                />


                                                <Button type="button" onClick={(e) => this.addNew()} variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4  mt-24 pr-24  add-ledger-btn">
                                                    Add New Ledger
                                                </Button>
                                            </div>
                                        </div>



                                        <div className="w-full  inline-block normal-payment-padding">

                                            <TextField
                                                className="w-full md:w-1/4 ml-16 "
                                                type="text"
                                                name="description"
                                                label="Description"
                                                value={this.state.ledgerAccountDetailObjById.DESCRIPTION}
                                                disabled
                                            />

                                            <TextField
                                                className="w-full md:w-1/6 ml-16 "
                                                type="number"
                                                name="amount"
                                                label="Amount"
                                                value={this.state.amount}
                                                onChange={this.handleTextBoxChange('amount')}
                                            />


                                            <Button type="button" onClick={(e) => this.addLedgerDetailsIntoTable()} variant="raised" size="small" color="secondary" className="{classes.button} w-full   mt-24 pr-24 normal-payment-btn">
                                                Add
                                            </Button>
                                        </div>
                                    </div>



                                    {/*  */}
                                    <div className="w-full sm:w-1/2 md:w-1/3 p-8  inline-block">
                                        {/* <div className="w-full md:w-1/6 ml-16  " style={{ marginLeft: 'auto' }}> */}
                                        <div className="w-full md:w-1/6 ml-16  " >
                                            <label>Attachment</label>
                                            <div className="MuiAvatar-root-915 w-96 h-96">
                                                <img id="profileImg" src={this.state.imageURL} className="w-96 h-96" />
                                            </div>

                                            <input accept="image/*" ref={(ref) => { this.uploadInput = ref; }} onChange={this.handleUploadImage} className="{classes.input} invisible" id="icon-button-file" type="file" />
                                            <label htmlFor="icon-button-file">
                                                <IconButton color="primary" className="{classes.button} " component="span">
                                                    <PhotoCamera />
                                                </IconButton>

                                                <div className="noramal-payment-img-close-btn">
                                                    <IconButton
                                                        className="{classes.button} normal-payment-remove-btn"
                                                        title="Remove"
                                                        onClick={(ev) => {
                                                            this.removeAttachment();
                                                        }}

                                                    >
                                                        <Icon className='text-red normal-payment-remove-btn'>cancel</Icon>
                                                    </IconButton>
                                                </div>


                                            </label>

                                            <div>
                                                <input ref={(ref) => { this.fileName = ref; }} value={Date.now()} type="hidden" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Divider className="md:mt-16 sm:mt-8 normal-devider-margins" />
                            </div>

                            <div className="w-full sm:w-1/2 md:w-2/3 p-8 inline-block normal-paymnt">
                                <div class="w-full">

                                    <div class="w-full bg-white h-auto mt-16">
                                        <h2 className="subtitle-color">Pay Mode</h2>

                                        <Select
                                            className="w-full md:w-1/4  mt-24 pr-24"
                                            name="form-field-name"
                                            placeholder="Select Pay Type"
                                            value={this.state.selectedPaymentType}
                                            onChange={this.loadPaymentTypes}
                                            options={this.state.loadPayTypes}
                                        />
                                    </div>

                                    <div className="recept-total-margin">
                                        <table className="w-full border-collapse" style={{ 'border-collapse': 'collapse' }}>
                                            <tbody>
                                                <td style={tdStyle}></td>
                                                <td align="right" className="text-18" style={tdStyle}>
                                                    <lable className="recept-lable-font-size"> Total Pay Amount  :  <span>{this.state.totalAmount}</span></lable>
                                                </td>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="w-full bg-white h-auto mt-16" hidden={this.state.cashCardHidden}>
                                        <div className="{classes.card}">
                                            <CardContent>
                                                <h3>If Cash</h3>
                                                <div className="w-full">
                                                    <Formsy
                                                        id="cardForm"
                                                        onValidSubmit={this.addCashAmountT}
                                                        ref={(form) => this.form = form}
                                                    >
                                                        <div className="w-full md:w-1/3">
                                                            <TextFieldFormsy
                                                                className="w-full md:w-2/3 pr-24 mt-16"
                                                                type="number"
                                                                name="cashAmount"
                                                                label="Amount"
                                                                required
                                                            />

                                                            <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/3 pr-24">
                                                                Add
                                                            </Button>
                                                        </div>
                                                    </Formsy>
                                                </div>

                                            </CardContent>
                                        </div>
                                    </div>


                                    <div class="w-full bg-white h-auto mt-16" hidden={this.state.cardCardHidden}>
                                        <div className="{classes.card}">
                                            <CardContent>
                                                <h3>If Card</h3>
                                                <div className="w-full">
                                                    <div className="w-full">
                                                        <Formsy
                                                            id="cardForm"
                                                            onValidSubmit={this.addCardAmountT}
                                                        >
                                                            <SelectFormsy
                                                                className="w-full md:w-1/6  mt-24 pr-24"
                                                                name="cardType"
                                                                label=""
                                                                value="none"
                                                                required
                                                            >
                                                                <MenuItem disabled value="none">
                                                                    <em>Card Type</em>
                                                                </MenuItem>
                                                                <MenuItem value="visa">Visa</MenuItem>
                                                                <MenuItem value="master">Master</MenuItem>

                                                            </SelectFormsy>

                                                            <SelectFormsy
                                                                className="w-full md:w-1/6  mt-24 pr-24"
                                                                name="bankName"
                                                                label=""
                                                                value="none"
                                                                required
                                                            >
                                                                <MenuItem disabled value="none">
                                                                    <em>Bank Name</em>
                                                                </MenuItem>
                                                                {/* <MenuItem value="boc">BOC</MenuItem>
                                                            <MenuItem value="peoples">People's</MenuItem> */}
                                                                {this.state.loadBanks.map(function (item, i) {
                                                                    return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                                                })}

                                                            </SelectFormsy>

                                                            <TextFieldFormsy
                                                                className="w-full md:w-1/6  mt-12 pr-24"
                                                                type="text"
                                                                name="cardNo"
                                                                label="Card No"
                                                                required
                                                            />

                                                            <TextFieldFormsy
                                                                id="date"
                                                                label="Expired Date"
                                                                name="expiredDate"
                                                                type="text"
                                                                className="{classes.textField} w-full md:w-1/6 mt-12 pr-24"
                                                                required
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />

                                                            <TextFieldFormsy
                                                                className="w-full md:w-1/6  mt-12 pr-24"
                                                                type="text"
                                                                name="amount"
                                                                label="Amount"

                                                                required
                                                            />

                                                            <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/6 pr-24">
                                                                Add
                                                            </Button>
                                                        </Formsy>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </div>
                                    </div>

                                    <div class="w-full bg-white h-auto mt-16" hidden={this.state.cardChequeHidden}>
                                        <div className="{classes.card}">
                                            <CardContent>
                                                <h3>If Cheque</h3>
                                                <div className="w-full sm:w-3/6 md:w-3/6">
                                                    <Formsy
                                                        id="cardForm"
                                                        onValidSubmit={this.addChequeAmountT}
                                                    >

                                                        <Select
                                                            className="w-full md:w-1/5  mt-24 pr-24"
                                                            name="form-field-name"
                                                            placeholder="Select Bank"
                                                            value={this.state.selectedBank}
                                                            onChange={this.loadBannkAccountNumers}
                                                            options={this.state.loadBanks}
                                                        />

                                                        {/* <SelectFormsy
                                                        className="w-full md:w-1/5  mt-24 pr-24"
                                                        name="bankName"
                                                        label=""
                                                        value="none"
                                                        required
                                                    >
                                                        <MenuItem disabled value="none">
                                                            <em>Bank Name</em>
                                                        </MenuItem>
                                                        {this.state.loadBanks.map(function (item, i) {
                                                            return <MenuItem value={item.value} onClick={(e) => this.loadBannkAccountNumers(item.value)}>{item.value}</MenuItem>;
                                                        })}

                                                    </SelectFormsy> */}

                                                        <SelectFormsy
                                                            className="w-full md:w-1/6  mt-24 pr-24"
                                                            name="accountNo"
                                                            label=""
                                                            value="none"
                                                            required
                                                        >
                                                            <MenuItem disabled value="none">
                                                                <em>Account No</em>
                                                            </MenuItem>

                                                            {this.state.bankAccountNumbers.map(function (item, i) {
                                                                return <MenuItem value={item.value}>{item.label}</MenuItem>;
                                                            })}

                                                        </SelectFormsy>


                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/5  mt-12 pr-24"
                                                            type="number"
                                                            name="chequeNo"
                                                            label="Cheque No"
                                                            validations={{
                                                                maxLength: 6
                                                            }}
                                                            validationErrors={{
                                                                maxLength: 'Max character length is 6'
                                                            }}
                                                            required
                                                        />

                                                        <TextFieldFormsy
                                                            id="date"
                                                            label="Cheque Date"
                                                            name="chequeDate"
                                                            type="date"
                                                            className="{classes.textField} w-full md:w-1/4 mt-12 pr-24"
                                                            required
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/5  mt-12 pr-24"
                                                            type="text"
                                                            name="amount"
                                                            label="Amount"
                                                            required
                                                        />

                                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/6 pr-24">
                                                            Add
                                                        </Button>
                                                    </Formsy>
                                                </div>
                                            </CardContent>
                                        </div>
                                    </div>

                                    <div class="w-full bg-white h-auto mt-16" hidden={this.state.cardBankDepositHidden}>
                                        <div className={classes.card}>
                                            <CardContent>
                                                <h3>If Bank Deposit</h3>
                                                <div className="w-full">
                                                    <Formsy
                                                        id="cardForm"
                                                        onValidSubmit={this.addBankDepositAmountT}
                                                    >

                                                        <SelectFormsy
                                                            className="w-full md:w-1/6  mt-24 pr-24"
                                                            name="bankName"
                                                            label=""
                                                            value="none"
                                                            required
                                                        >
                                                            <MenuItem disabled value="none">
                                                                <em>Bank Name</em>
                                                            </MenuItem>
                                                            {this.state.loadBanks.map(function (item, i) {
                                                                return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                                            })}

                                                        </SelectFormsy>

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/6  mt-12 pr-24"
                                                            type="text"
                                                            name="branch"
                                                            label="Branch"
                                                            required
                                                        />

                                                        <TextFieldFormsy
                                                            id="date"
                                                            label="Deposit Date"
                                                            name="depositDate"
                                                            type="date"
                                                            className="{classes.textField} w-full md:w-1/4 mt-12 pr-24"
                                                            required
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/6  mt-12 pr-24"
                                                            type="number"
                                                            name="receiptNo"
                                                            label="Receipt No"
                                                            required
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/6  mt-12 pr-24"
                                                            type="text"
                                                            name="amount"
                                                            label="Amount"
                                                            required
                                                        />

                                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/6 pr-24 normal-payment-add-btn">
                                                            Add
                                                        </Button>
                                                    </Formsy>
                                                </div>
                                            </CardContent>
                                        </div>
                                    </div>
                                    <div class="w-full bg-white h-auto mt-48">
                                        <h2 className="subtitle-color payment-mode-margin">Payment Mode Details</h2>

                                        <ReactTable
                                            getTrProps={(state, rowInfo, column) => {
                                                return {
                                                    className: "cursor-pointer",
                                                    onClick: (e, handleOriginal) => {

                                                    }
                                                }
                                            }}
                                            data={this.state.paymentModeAr}
                                            columns={[
                                                {
                                                    Header: "rowId",
                                                    accessor: "rowIdpm",
                                                    show: false
                                                },

                                                {
                                                    Header: "Payment Type",
                                                    accessor: "paymentType",
                                                    show: false
                                                },

                                                {
                                                    Header: "Payment Type",
                                                    accessor: "paymentTypeName",
                                                    filterable: true
                                                },

                                                {
                                                    Header: "Bank",
                                                    accessor: "bank",
                                                    filterable: true
                                                },

                                                {
                                                    Header: "Cheque / Card No",
                                                    accessor: "number",
                                                    filterable: true
                                                },

                                                {
                                                    Header: "Date",
                                                    accessor: "date",
                                                    filterable: true
                                                },

                                                {
                                                    Header: "Amount",
                                                    accessor: "paymentAmount",
                                                    filterable: true
                                                },
                                                {
                                                    Header: "Action",
                                                    // accessor: "su",
                                                    width: 128,
                                                    Cell: row => (

                                                        <div className="flex items-center  w-8 h-8">
                                                            <Tooltip
                                                                enterDelay={300}
                                                                id="tooltip-controlled"
                                                                leaveDelay={300}
                                                                onClose={this.handleTooltipClose}
                                                                onOpen={this.handleTooltipOpen}
                                                                open={this.state.open}
                                                                placement="bottom"
                                                                title="Remove payment Mode"
                                                            >
                                                                <IconButton
                                                                    onClick={(e) => {
                                                                        if (row) {

                                                                            this.removePaymentMode(row.original.rowIdpm, row.original.paymentAmount);

                                                                        }
                                                                    }}

                                                                >
                                                                    <Icon className="text-red">cancel</Icon>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                    )
                                                }

                                            ]}
                                            defaultPageSize={5}
                                            className="-striped -highlight"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="w-full sm:w-1/2 md:w-1/3 p-8  inline-block normalacc-table-margin">
                                <div class="w-full bg-white h-auto mt-8">

                                    <ReactTable
                                        getTrProps={(state, rowInfo, column) => {
                                            return {
                                                className: "cursor-pointer",
                                                onClick: (e, handleOriginal) => {

                                                }
                                            }
                                        }}
                                        data={this.state.ledgerAccountDetailObjAr}
                                        columns={[
                                            {
                                                Header: "rowId",
                                                accessor: "rowIdad",
                                                show: false
                                            },

                                            {
                                                Header: "Ledger Account Id",
                                                accessor: "ledgerAccId",
                                                show: false
                                            },
                                            {
                                                Header: "Ledger Account",
                                                accessor: "ledgerAccountName",
                                                width: 130,
                                                className: "justify-start"
                                            },

                                            {
                                                Header: "Description",
                                                accessor: "description",
                                                width: 100,
                                                className: "justify-start"
                                                // filterable: true
                                            },
                                            {
                                                Header: "Amount",
                                                accessor: "amount",
                                                width: 100,
                                                className: "justify-start"
                                                // filterable: true
                                            },
                                            {
                                                Header: "Action",
                                                className: "justify-start",
                                                width: 60,
                                                Cell: row => (

                                                    <div className="flex items-center  w-8 h-8">
                                                        <Tooltip
                                                            enterDelay={300}
                                                            id="tooltip-controlled"
                                                            leaveDelay={300}
                                                            onClose={this.handleTooltipClose}
                                                            onOpen={this.handleTooltipOpen}
                                                            open={this.state.open}
                                                            placement="bottom"
                                                            title="View Payment"
                                                        >
                                                            <IconButton
                                                                onClick={(e) => {
                                                                    if (row) {

                                                                        viewLedgerAccount = row.original.ledgerAccountName;
                                                                        viewDescription = row.original.description;
                                                                        viewAmount = row.original.amount;
                                                                        this.setState({ viewPayment: true });
                                                                    }
                                                                }}

                                                            >
                                                                <Icon className="text-green">remove_red_eye</Icon>
                                                            </IconButton>
                                                        </Tooltip>

                                                        <Dialog
                                                            open={this.state.viewPayment}
                                                            onClose={this.handleClose}
                                                            aria-labelledby="form-dialog-title"
                                                        >
                                                            <DialogTitle id="form-dialog-title">Payment</DialogTitle>
                                                            <DialogContent>

                                                                <div>

                                                                    <Formsy
                                                                        onValidSubmit={this.onView}

                                                                        ref={(form) => this.form = form}
                                                                        className="flex flex-col justify-center"
                                                                    >

                                                                        <TextFieldFormsy
                                                                            className="w-full"
                                                                            type="text"
                                                                            name="viewLedgerAccount"
                                                                            label="Ledger Account"
                                                                            value={viewLedgerAccount}
                                                                            disabled
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-full"
                                                                            type="text"
                                                                            name="viewDescription"
                                                                            label="Description"
                                                                            value={viewDescription}
                                                                            disabled
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-full"
                                                                            type="text"
                                                                            name="viewAmount"
                                                                            label="Amount"
                                                                            value={viewAmount}
                                                                            disabled
                                                                        />

                                                                        <DialogActions>
                                                                            <Button onClick={this.handleCloseView} color="primary">
                                                                                Cancel
                                                                            </Button>
                                                                            {/* <Button color="primary" autoFocus
                                                                            type="submit"
                                                                        >
                                                                            Inactive
                                                                        </Button> */}
                                                                        </DialogActions>
                                                                    </Formsy>
                                                                </div>
                                                            </DialogContent>
                                                        </Dialog>


                                                        <Tooltip
                                                            enterDelay={300}
                                                            id="tooltip-controlled"
                                                            leaveDelay={300}
                                                            onClose={this.handleTooltipClose}
                                                            onOpen={this.handleTooltipOpen}
                                                            open={this.state.open}
                                                            placement="bottom"
                                                            title="Remove Payment"
                                                        >
                                                            <IconButton
                                                                onClick={(e) => {
                                                                    if (row) {

                                                                        this.removeLedgerAccDetail(row.original.rowIdad, row.original.amount);
                                                                    }
                                                                }}

                                                            >
                                                                <Icon className="text-red">cancel</Icon>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                )
                                            }

                                        ]}
                                        defaultPageSize={5}
                                        className="-striped -highlight"
                                    />

                                    {/* <div>
                                        <table className="w-full border-collapse" style={{ 'border-collapse': 'collapse' }}>
                                            <tbody>
                                                <td style={tdStyle}></td>
                                                <td align="right" className="text-18" style={tdStyle}>
                                                    Total : <span>{this.state.totalAmount}</span>
                                                </td>
                                            </tbody>
                                        </table>
                                    </div> */}

                                </div>
                            </div>

                            <div className="w-full md:w-1/3 float-right mb-16">
                                <Button type="button" onClick={(ev) => this.saveNormalPayment()} variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 pr-24 -ml-24 mr-8 normal-save-btn-margin">
                                    Save
                                </Button>

                                <Button type="button" onClick={(ev) => this.draftNormalPayment()} variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 pr-24 -ml-24 mr-8">
                                    Draft
                                </Button>

                                <Button type="button" /* onClick={this.resetForm} */ onClick={this.clearFields} variant="raised" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 pr-24 mr-8">
                                    Clear
                                </Button>

                                <Button type="button" variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 pr-24">
                                    Help
                                </Button>
                            </div>

                            {this.redirectToDN()}
                        </div>
                    }
                />
            );
        }
    }
}


export default withStyles(styles, { withTheme: true })(withAlert(NormalPayment));


// WEBPACK FOOTER //
// ./src/main/content/accounting/normalPayment/NormalPayment.js